import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import html from 'html-react-parser'
import styled from '@emotion/styled'

import {
  Heading,
  Container,
  Info,
  IconWrapper
} from '@/components/parkings/NoResults.styled'
import { getNavigationIcon } from '@/constants/navigationAssets'
import { colors } from '@/styles/theme'

function NoResults() {
  const { t } = useTranslation('parkings')
  const router = useRouter()

  const handleGoBack = () => {
    if (window.history.length > 1) {
      router.back()
    } else {
      router.push('/')
    }
  }

  return (
    <Container>
      <IconWrapper>
        <img
          src={getNavigationIcon('noResults')}
          alt="No results found"
          loading="lazy"
        />
      </IconWrapper>
      <Heading>{html(t('noResults.title'))}</Heading>
      <Info>
        <StyledGoBack
          //prevent JavaScript default behavior
          href="javascript:void(0)"
          onClick={handleGoBack}
          role="button"
        >
          {t('searchNearParking.noResults.backbtn')}
        </StyledGoBack>
      </Info>
    </Container>
  )
}

export default NoResults

const StyledGoBack = styled.a`
  cursor: pointer;
  color: ${colors.twilightBlue};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`
